import { userConstants, authConstants } from '../_constants'
import { userActions } from '../_actions'

const user = userActions.getCurrentToken()


const initialState = user ? { loggedIn: true, user,message:'',error:'' } : {message:'',error:''}

export function authentication(state = initialState, action) {
  //console.log(action)
  switch (action.type) {
  case userConstants.LOGIN_REQUEST:
    return {
      loggingIn: true,
      user: action.user
    }
  case userConstants.LOGIN_SUCCESS:
    console.log(action.message)
    if (action.user.message === 'success') {
      localStorage.setItem(authConstants.TOKEN_KEY, action.user.token)
      localStorage.setItem(authConstants.USER_NAME, action.user.firstName + '' + action.user.lastName)
      localStorage.setItem(authConstants.USER, action.user)
      localStorage.setItem(authConstants.USERID, action.user.id)
    }
    return {
      ...state,
      loggedIn: true,
      user: action.user,
      message:action.user.message
    }
  case userConstants.LOGIN_FAILURE:
    return {
      ...state,
      error: action.error,
      message: action.error.message
    }
  case userConstants.LOGOUT:
    return {}
  default:
    return state
  }
}
